import { Component } from '@angular/core';

@Component({
    selector: 'app-blog-ocr-pdf',
    imports: [],
    templateUrl: './blog-ocr-pdf.component.html',
    styleUrl: './blog-ocr-pdf.component.css'
})
export class BlogOcrPdfComponent {

}
